import { useState } from 'react';
import {
  OfferConfirmModal,
  OfferUpdateModal,
  OfferCancelModal,
  OfferConfirmPaymentModal,
  OfferPayModal,
  ImageGallery,
  fullScreenButtonClick,
  ShareImagesModal,
  ContainerListModal,
  OfferCancelPaidModal,
} from '../../design-system';
import { OffersPage, OffersHeader, OffersBody } from './OffersComponents';
import { useStore } from '../../context';
import { useStatesWithFilterCounter } from '../../hooks';
import { showToRoles } from '../../utils';
import { RoleGuard } from '../../routes';

export const Offers = () => {
  const {
    state: {
      user: { data: user },
    },
  } = useStore();
  const [states, setStates, filteredStates] = useStatesWithFilterCounter(
    {
      offerDirection: '',
      number: '',
      type: 'All',
      status: '',
      buyerClientId: '',
      listMode: 'latest',
    },
    {
      offerDirection: showToRoles('adminRead', user) ? 'received' : 'sent',
      status: 'ACCEPTED',
    },
  );

  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [checkIndexs, setCheckIndexs] = useState<number[]>([]);
  const [images, setImages] = useState<any>([]);
  const [containerList, setContainerList] = useState<any>();

  const handleCheckboxChange = (i: number) => {
    if (isNaN(i)) {
      const allCheckIndexs = Array.from({ length: data.length }, (_, i) => i);
      setCheckIndexs(checkIndexs.length === data.length ? [] : allCheckIndexs);
      return;
    }

    setCheckIndexs((prev) =>
      prev.includes(i) ? prev.filter((index) => index !== i) : [...prev, i],
    );
  };

  const handleClickImage = (images: any[]) => {
    setImages(images.map(({ url }) => url));
    fullScreenButtonClick();
  };

  return (
    <RoleGuard
      roles={[
        'SUPER_ADMIN',
        'YARD_COMPANY_ADMIN',
        'YARD_COMPANY_VIEWER',
        'YARD_MANAGER',
        'CLIENT_MANAGER',
        'CLIENT_DISPATCHER',
      ]}
    >
      <OffersPage innerScroll>
        <OffersHeader
          totalCount={totalCount}
          data={data}
          containerList={containerList}
          setContainerList={setContainerList}
          checkIndexs={checkIndexs}
        />
        <OffersBody
          user={user}
          states={states}
          setStates={setStates}
          filteredStates={filteredStates}
          setData={setData}
          setTotalCount={setTotalCount}
          containerList={containerList}
          setContainerList={setContainerList}
          checkIndexs={checkIndexs}
          setCheckIndexs={setCheckIndexs}
          handleCheckboxChange={handleCheckboxChange}
          handleClickImage={handleClickImage}
        />
      </OffersPage>
      <ContainerListModal validContainers />
      <OfferConfirmPaymentModal />
      <OfferConfirmModal />
      <OfferUpdateModal />
      <OfferCancelModal />
      <OfferCancelPaidModal />
      <OfferPayModal />
      <ImageGallery photos={images} startIndex={0} />
      <ShareImagesModal />
    </RoleGuard>
  );
};
